import { View, DataView, ContextMenu, Dialog } from 'web-mojo';
import { VendingTransaction } from '@portal/models/VendingTransaction.js';

const STATUS_BADGES = {
    captured: '<span class="badge bg-success">Captured</span>',
    refunded: '<span class="badge bg-secondary">Refunded</span>',
    failed:   '<span class="badge bg-danger">Failed</span>',
    reversed: '<span class="badge bg-warning text-dark">Reversed</span>',
};

class TransactionView extends View {
    constructor(options = {}) {
        super({
            className: 'transaction-view',
            ...options
        });

        this.template = `
            <div data-container="header"></div>
            <div data-container="details-view"></div>
        `;
    }

    async onInit() {
        const status = this.model.get('status') || 'captured';

        // Header
        this.header = new View({
            containerId: 'header',
            template: `
            <div class="d-flex justify-content-between align-items-start mb-3">
                <div class="d-flex align-items-center gap-3">
                    <div class="d-flex align-items-center justify-content-center rounded bg-light"
                         style="width:42px;height:42px;flex-shrink:0">
                        <i class="bi bi-credit-card fs-5 text-secondary"></i>
                    </div>
                    <div>
                        <h5 class="mb-0">{{formattedAmount}}</h5>
                        <div class="text-muted small">{{model.machine.name|default('—')}}</div>
                    </div>
                </div>
                <div class="d-flex align-items-start gap-2">
                    {{{statusBadge}}}
                    <div data-container="context-menu"></div>
                </div>
            </div>`
        });
        this.header.formattedAmount = this.model.amountFormatted();
        this.header.statusBadge = STATUS_BADGES[status] || `<span class="badge bg-secondary">${status}</span>`;
        this.header.setModel(this.model);
        this.addChild(this.header);

        // Context menu — refund if captured
        if (status === 'captured') {
            const contextMenu = new ContextMenu({
                containerId: 'context-menu',
                className: 'context-menu-view header-menu-absolute',
                context: this.model,
                config: {
                    icon: 'bi-three-dots-vertical',
                    items: [
                        { label: 'Refund', action: 'refund', icon: 'bi-arrow-counterclockwise', className: 'text-danger' },
                    ]
                }
            });
            this.addChild(contextMenu);
        }

        // Details — DataView
        const fields = [
            { name: 'id', label: 'Transaction ID', colSize: 12 },
            { name: 'created', label: 'Date', formatter: 'datetime', colSize: 6 },
            { name: 'machine.name', label: 'Terminal', colSize: 6 },
            { name: 'status', label: 'Status', colSize: 6 },
            { name: 'currency', label: 'Currency', colSize: 6 },
            { name: 'payment_processor.processor_type', label: 'Processor', colSize: 6 },
        ];

        if (this.model.get('metadata')?.unlock_status) {
            fields.push({ name: 'metadata.unlock_status', label: 'Unlock', colSize: 6 });
        }
        if (this.model.get('metadata')?.payment_intent_id) {
            fields.push({ name: 'metadata.payment_intent_id', label: 'Payment Ref', colSize: 12 });
        }

        this.detailsView = new DataView({
            model: this.model,
            containerId: 'details-view',
            showEmptyValues: true,
            fields: fields
        });
        this.addChild(this.detailsView);
    }

    async onActionRefund() {
        const formatted = this.model.amountFormatted();
        const confirmed = await Dialog.confirm({
            title: 'Refund Transaction',
            message: `Refund ${formatted}? This will reverse the payment and restore inventory.`,
            confirmText: 'Refund',
            confirmClass: 'btn-danger',
        });
        if (!confirmed) return;

        const response = await this.model.save({ refund: true });
        if (!response.success || !response.data.status) {
            app.toast.error(response.data?.error || 'Refund failed');
            return;
        }
        app.toast.success('Refund processed');
        this.render();
    }

    _onModelChange() {}
}

VendingTransaction.VIEW_CLASS = TransactionView;

export default TransactionView;
